import React, { useState } from "react";
import { Box, Label, Text, IconButton } from "@primer/react";
import {
  PencilIcon,
  PersonIcon,
  DeviceMobileIcon,
  PersonAddIcon,
  CheckIcon,
  ClockIcon,
  CalendarIcon,
  CommentDiscussionIcon,
} from "@primer/octicons-react";
import moment from "moment";
import PhuHuynhCSKHDetailModal from "./detail-modal/PhuHuynhCSKHDetailModal";

interface ChamSocKhachHang {
  id: number;
  da_xu_ly: boolean;
  ten_khach_hang: string;
  dien_thoai: string;
  ma_hs?: string;
  ho_ten_hoc_sinh?: string;
  is_request: boolean;
  ngay_hen_tra_loi?: string;
  ngay_xu_ly?: string;
  noi_dung: string;
  nguoi_tao: string;
  ngay_tao: string;
  ghi_chu?: string;
  ket_qua_xu_ly?: string;
}

interface PhuHuynhCSKHItemProps {
  ts_chamsockhachhang: ChamSocKhachHang;
  onChanged: () => void;
}

const PhuHuynhCSKHItem: React.FC<PhuHuynhCSKHItemProps> = ({
  ts_chamsockhachhang,
  onChanged,
}) => {
  const [isShowEditModal, setShowEditModal] = useState<boolean>(false);
  const { da_xu_ly, is_request } = ts_chamsockhachhang;

  return (
    <Box
      sx={{
        p: 2,
        mb: 2,
        border: "1px solid",
        borderColor: da_xu_ly ? "success.emphasis" : "attention.emphasis",
        borderRadius: 2,
        fontSize: 1,
        background: 'white',
      }}
    >
      {/* Header - All information */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        {/* Left side - All info */}
        <Box sx={{ display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap" }}>
          {/* Status & Type */}
          <Label
            sx={{
              bg: da_xu_ly ? "success.emphasis" : "attention.emphasis",
              color: "white",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {da_xu_ly ? <CheckIcon size={12} /> : <ClockIcon size={12} />}
              <Text>{da_xu_ly ? "Đã xử lý" : "Chưa xử lý"}</Text>
            </Box>
          </Label>
          <Label variant={is_request ? "done" : "accent"}>
            {is_request ? "Yêu cầu PH" : "Ghi chú TS"}
          </Label>

          {/* Contact Info */}
          {/* <Text sx={{ display: "flex", alignItems: "center", gap: 1, color: "fg.muted" }}>
            <PersonIcon size={12} />
            {ts_chamsockhachhang.ten_khach_hang}
          </Text>
          <Text sx={{ display: "flex", alignItems: "center", gap: 1, color: "fg.muted" }}>
            <DeviceMobileIcon size={12} />
            {ts_chamsockhachhang.dien_thoai}
          </Text> */}
          {ts_chamsockhachhang.ma_hs && (
            <Text sx={{ display: "flex", alignItems: "center", gap: 1, color: "fg.muted" }}>
              <PersonAddIcon size={12} />
              {ts_chamsockhachhang.ma_hs} - {ts_chamsockhachhang.ho_ten_hoc_sinh}
            </Text>
          )}

          {/* Dates */}
          {ts_chamsockhachhang.ngay_hen_tra_loi && (
            <Text sx={{ color: "attention.fg", fontSize: 0 }}>
              Hẹn: {moment(ts_chamsockhachhang.ngay_hen_tra_loi).format("DD/MM/YYYY")}
            </Text>
          )}
          {ts_chamsockhachhang.ngay_xu_ly && (
            <Text sx={{ color: "success.fg", fontSize: 0 }}>
              Xử lý: {moment(ts_chamsockhachhang.ngay_xu_ly).format("DD/MM/YYYY")}
            </Text>
          )}
        </Box>

        {/* Edit button */}
        <IconButton
          icon={PencilIcon}
          aria-label="Edit"
          variant="invisible"
          size="small"
          onClick={() => setShowEditModal(true)}
        />
      </Box>

      {/* Content */}
      <Box 
        sx={{ 
          borderTop: "1px solid",
          borderColor: "border.default",
          pt: 2,
        }}
      >
        <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
          <CommentDiscussionIcon size={14}/>
          <Text>{ts_chamsockhachhang.noi_dung}</Text>
        </Box>

        {/* Footer */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            color: "fg.muted",
            fontSize: 0,
            borderTop: "1px solid",
            borderColor: "border.default",
            pt: 2,
          }}
        >
          <Text>{ts_chamsockhachhang.nguoi_tao} ({ts_chamsockhachhang.ngay_tao})</Text>
          {ts_chamsockhachhang.ket_qua_xu_ly && (
            <Text>Kết quả: {ts_chamsockhachhang.ket_qua_xu_ly}</Text>
          )}
        </Box>
      </Box>

      {isShowEditModal && (
        <PhuHuynhCSKHDetailModal
          id={ts_chamsockhachhang.id}
          onCancel={() => setShowEditModal(false)}
          onSuccess={() => {
            setShowEditModal(false);
            onChanged();
          }}
        />
      )}
    </Box>
  );
};

export default PhuHuynhCSKHItem;
